import { v4 } from 'uuid';
import getCookieOrMeta from './getCookieOrMeta';
import setCookie from './setCookie';

function generateNewVisitorId() {
  window.components.tracking.visitor_id = v4();
  setCookie('visitor_id', window.components.tracking.visitor_id);
  return window.components.tracking.visitor_id;
}

/**
 * Returns the visitor-id meta tag value, if present. Will send a NR notice error
 * if visitor-id is not present (since it should always be present)
 */
export default function getVisitorId() {
  if (!window.components) window.components = {};
  if (!window.components.tracking) window.components.tracking = {};
  const visitorId = getCookieOrMeta('visitor-id') || window.components.tracking.visitor_id;

  // return visitor id if it's present,  otherwise log a NR notice error and return null
  if (visitorId) return visitorId;

  // otherwise notify newrelic and generate a new visitor id
  if (window.newrelic) window.newrelic.addPageAction('missing-visitor-id');
  return generateNewVisitorId();
}
